import {all} from "@redux-saga/core/effects"
import {authSaga} from "./Auth/Saga";
import {modalSaga} from "./Modal/Saga";

import {pickupSaga} from "./Pickup/Saga";
import {contactSaga} from "./Contact/Saga";
import {paymentTypesSaga} from "./PaymentType/Saga";
import packingTypeSaga from "./PackingType/Saga";
import {addressSaga} from "./Address/Saga";
import {citySaga} from "./City/Saga";
import {zoneSaga} from "./Zone/Saga";
import billingSaga from "./Billing/Saga";
import {shipmentSaga} from "./Shipments/Saga";

export default function * rootSaga() {
  yield all ([
    authSaga(),
    modalSaga(),
    pickupSaga(),
    contactSaga(),
    paymentTypesSaga(),
    packingTypeSaga(),
    addressSaga(),
    citySaga(),
    zoneSaga(),
    billingSaga(),
    shipmentSaga()
  ]);
};
